import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

/**
 * Glassmorphism surface. `hoverable` adds a spring lift + cursor spotlight.
 * The spotlight follows the pointer via CSS vars (no React re-render).
 * For 3D tilt, wrap this in <Tilt> from components/fx.
 */
const GlassCard = forwardRef(function GlassCard(
  { children, className, hoverable = false, gradientBorder = false, spotlight, beam = false, ...props },
  ref
) {
  const withSpotlight = spotlight ?? hoverable;

  const onPointerMove = withSpotlight
    ? (e) => {
        const el = e.currentTarget;
        const r = el.getBoundingClientRect();
        el.style.setProperty('--mx', `${(((e.clientX - r.left) / r.width) * 100).toFixed(1)}%`);
        el.style.setProperty('--my', `${(((e.clientY - r.top) / r.height) * 100).toFixed(1)}%`);
      }
    : undefined;

  return (
    <motion.div
      ref={ref}
      onPointerMove={onPointerMove}
      whileHover={hoverable ? { y: -4 } : undefined}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
      className={cn(
        'glass rounded-xl shadow-card',
        withSpotlight && 'spotlight',
        gradientBorder && 'gradient-border',
        beam && 'beam',
        hoverable && 'cursor-pointer transition-shadow duration-300 hover:shadow-glow',
        className
      )}
      {...props}
    >
      {children}
    </motion.div>
  );
});

export default GlassCard;
